import { styled } from "@mui/material/styles";
import { Toolbar } from "@mui/material";

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  boxShadow: "0 0 5px #00000030",
  [theme.breakpoints.up("tablet")]: {
    height: theme.sizes.desktop.header.height,
  },
  display: "block",
}));
